module.exports = __webpack_public_path__ + "resources/img/logo_ACCESSPORT.96f9facb76a656990700d7f007c58397.png";